export type FrequentFlyerField = keyof Omit<App.BusinessTraveller.TravellerFormLoyaltyPrograms, 'hotelLoyaltyProgramMemberId'>

export const frequentFlyerNumberTravellerFormFields: Array<[FrequentFlyerField, FrequentFlyerField]> = [
  ['frequentFlyerAirline1', 'frequentFlyerNumber1'],
  ['frequentFlyerAirline2', 'frequentFlyerNumber2'],
]
